import { render, staticRenderFns } from "./InstallForm.vue?vue&type=template&id=2719ac74&"
import script from "./InstallForm.vue?vue&type=script&lang=ts&"
export * from "./InstallForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports